module.exports = __webpack_public_path__ + "static/logo-893547af93bc434b40a6317536083f60.png";